// extracted by mini-css-extract-plugin
export default {"button":"sq-z","reviewSort":"tq-z"};